module.exports = __webpack_public_path__ + "media/images/cat2-9a4c38880765d065649caf4eb1db41e2.png";